// import ForSample from './sample'
import ForDrawing from './drawing'
import ForCode from './code'
import ForLaTeX from './latex'
import ForImage from './image'

export const InsertFormArray = [
  ForImage, ForDrawing, ForCode, ForLaTeX
]

export const InsertFormObject = {
  Drawing: ForDrawing,
  Image: ForImage,
  Code: ForCode,
  LaTeX: ForLaTeX
}
